import { render, staticRenderFns } from "./SalepagePopup.vue?vue&type=template&id=5b1c5e35&scoped=true&"
import script from "./SalepagePopup.vue?vue&type=script&lang=js&"
export * from "./SalepagePopup.vue?vue&type=script&lang=js&"
import style0 from "./SalepagePopup.vue?vue&type=style&index=0&id=5b1c5e35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1c5e35",
  null
  
)

export default component.exports